import type { ReactNode } from 'react';
import { Row, RowList } from '@src/components/RowList/RowList';
import './ParticipantTable.css';

export interface ParticipantTableRowListProps {
  children: ReactNode;
  columns?: { label: ReactNode; leading?: ReactNode; className?: string; sortDirection?: 'ascending' | 'descending'; sortPriority?: number; onSort?: () => void }[];
  /** Pad with invisible rows so the last page matches full pages. */
  placeholderCount?: number;
  testId?: string;
}

/** Row list for participant tables — keeps pagination from jumping on the last page. */
export function ParticipantTableRowList({
  children,
  columns,
  placeholderCount = 0,
  testId,
}: ParticipantTableRowListProps) {
  if (columns) return (
    <table className="participant-data-table" data-testid={testId}>
      <thead><tr>{columns.map((column, index) => <th key={index} scope="col" className={column.className} aria-sort={column.onSort ? (column.sortPriority && column.sortPriority > 1 ? 'other' : column.sortDirection ?? 'none') : undefined}><div className="participant-data-table__heading">{column.leading}{column.onSort ? <button type="button" className="participant-data-table__sort" onClick={column.onSort}>{column.label}<span aria-hidden="true">{column.sortDirection === 'ascending' ? '↑' : column.sortDirection === 'descending' ? '↓' : '—'}{column.sortPriority ? <sup>{column.sortPriority}</sup> : null}</span></button> : column.label}</div></th>)}</tr></thead>
      <tbody>{children}</tbody>
    </table>
  );
  return (
    <RowList testId={testId}>
      {children}
      {placeholderCount > 0
        ? Array.from({ length: placeholderCount }, (_, index) => (
            <Row
              key={`participant-table-placeholder-${index}`}
              size="large"
              align="center"
              className="participant-table__row-placeholder"
              aria-hidden
            />
          ))
        : null}
    </RowList>
  );
}
